namespace appn.views.data.group {

    class InitArgs {
        formElements: Array<FormElement> = [];
        selectedFormId: string = emptyString;
        entryId: string = emptyString;
        groupDataName: string = emptyString;
        dataGroupDataTable: string = emptyString;
        repeatIndex: number = -1;
    }

    let _initArgs: InitArgs;

    let _datatable: any = null;

    export function init(args: InitArgs) {
        _initArgs = args;
        addEvents();
        createDataTable();
    }

    function addEvents() {
        $(document).on('click', 'a[id^="viewGroup_"]', function (this:HTMLElement, e:Event) {
            e.preventDefault();
            const link = $(this);
            const groupIndex = Number((link.attr('id') as string).split('_')[2]);
            const href = `${link.attr('href')}?repeatIndex=${groupIndex}`;
            return appn.ui.popup(href);
        });
    }

    function createDataTable() {
        _datatable = appn.dataTable.create('.dataTable', {
            sDom: appn.dataTable.genSDom(0, 0, 0), // sDom empty
            sAjaxSource: _initArgs.dataGroupDataTable,
            scrollX: '100%',
            fnServerData: function(data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', _initArgs.selectedFormId),
                    appn.dataTable.getStateOrDefault('sCustom_1', _initArgs.entryId),
                    appn.dataTable.getStateOrDefault('sCustom_2', _initArgs.groupDataName),
                    appn.dataTable.getStateOrDefault('sCustom_3', _initArgs.repeatIndex));
            },
            aoColumns: getDtColConfiguration(),
            searching: false,
            fnInitComplete: function() {

                appn.saveMeState.init(function(): any {
                    _datatable.fnDraw(false);
                },
                    function(): any {
                        _datatable.fnDraw(false);
                    }, '.dataTables_filter');
            },
            fnDrawCallback: function() {
                appn.dialog.singleEntryExport.init();

                $('td').on('click', 'a#viewMedia', function(event) {
                    event.preventDefault();
                    appn.dialog.viewMediaFromElement($(this));
                });
            }
        });
    }

    function getDtColConfiguration(): Array<IDTColumns> {
        const columns: Array<IDTColumns> = [];

        for (let i = 0; i < _initArgs.formElements.length; i++)
            columns.push({
                bSortable: false,
                sWidth: '200px',
                sName: _initArgs.formElements[i].name,
                sDefaultContent: appn.emptyString
            } as IDTColumns);

        return columns;
    }

}

